import {
    FETCH_ORDER_BOOKING_ACTIVITIES_FAILURE,
    FETCH_ORDER_BOOKING_ACTIVITIES_SUCCESS,
} from 'store/actions/types';

const initialState = {
    data: {},
};

export default function orderBookingActivites(state = initialState, action) {
    switch (action.type) {
        case FETCH_ORDER_BOOKING_ACTIVITIES_FAILURE:
            return Object.assign({}, state, {
                data: {},
            });
        case FETCH_ORDER_BOOKING_ACTIVITIES_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.payload.id]: action.payload.response,
                }),
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/orderBookingActivitiesReducer.js